import {
    DATE_JOINED,
    IN_LAST_7_DAYS,
    LAST_LOGIN,
    LOGIN_NAME_AGE,
    LONG_TIME_AGO,
    THERE_ARE_MORE_RESULTS,
} from 'mk/autogenerated/translations/UsersList.e9ea3496e9b021ff649070964ddb0ab8'
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import { UserStatsEntity } from 'mk2/apps/users/schemas';
import { AvatarImg } from 'mk2/components/AvatarImg';
import { Link } from 'mk2/components/Link';
import { dateLocal } from 'mk2/helpers/timeformat';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './UsersList.mscss';

interface OwnProps {
    usersStats: UserStatsEntity[];
    isMobile: boolean;
    hasMore: boolean;
}

type Props = OwnProps;

const UsersList = React.memo<Props>(
    ({ usersStats, isMobile, hasMore }) => {
        return (
            <div className={styles.UsersList}>
                <div className={styles.UsersList__header}>
                    {!isMobile && [
                        <div className={styles.UsersList__header__firstItem} key="login">{LOGIN_NAME_AGE}</div>,
                        <div className={styles.UsersList__header__secondItem} key="lastLogin">{LAST_LOGIN}</div>,
                        <div className={styles.UsersList__header__thirdItem} key="dateJoined">{DATE_JOINED}</div>,
                    ]}
                </div>
                {usersStats.map((userStat, idx) => {
                    return (
                        <div className={styles.ListItem} key={idx}>
                            <div className={styles.ListItem__firstCol}>
                                <AvatarImg
                                    size={50}
                                    user={userStat.user}
                                    href={url(blogsProfileUrl, { username: userStat.user.username })}
                                    className={styles.ListItem__firstCol__avatar}
                                />
                                <div className={styles.ListItem__firstCol__info}>
                                    <Link
                                        to={url(blogsProfileUrl, { username: userStat.user.username })}
                                        className={styles.ListItem__firstCol__info__link}
                                    >
                                        {userStat.user.username}
                                    </Link>
                                    <span className={styles.ListItem__secondaryText}>{userStat.county}</span>
                                    <span className={styles.ListItem__secondaryText}>{userStat.childrenInfo}</span>
                                        <div className={styles.ListItem__secondaryText}>
                                            {isMobile && [
                                                <div key="lastLogin"><span>{LAST_LOGIN}:</span>&nbsp;{userStat.isActive ? IN_LAST_7_DAYS : LONG_TIME_AGO}</div>,
                                                <div key="joinedDate">{DATE_JOINED}:&nbsp;<span className={styles.ListItem__secondaryText}>{dateLocal(userStat.signupDate)}</span></div>,
                                            ]}
                                        </div>
                                </div>
                            </div>
                            {!isMobile && (
                                <>
                                    <div className={styles.ListItem__secondCol}>
                                        <span className={styles.ListItem__secondaryText}>{userStat.isActive ? IN_LAST_7_DAYS : LONG_TIME_AGO}</span>
                                    </div>
                                    <div className={styles.ListItem__thirdCol}>
                                        <span className={styles.ListItem__secondaryText}>{dateLocal(userStat.signupDate)}</span>
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
                {hasMore &&
                    <div className={styles.ListItem__moreResults}>{THERE_ARE_MORE_RESULTS}</div>
                }
            </div>
        );
    },
);

UsersList.displayName = 'SellerShowPhone';

export default UsersList;
